import { z } from "zod";
import {
  DTODataSourceFigmaCreatePayload,
  DTODataSourceFigmaImportPayload,
  DTODataSourceResponse,
  DTODataSourcesListResponse,
  DTODataSourcesStorybookResponse,
  DTODataSourceStorybookCreatePayload,
  DTOFigmaSourceUpdatePayload,
  DTOImportJobResponse,
  DTOStorybookImportPayload,
  DTOStorybookSourceUpdatePayload,
} from "../../dto";
import { RequestExecutor } from "../../transport/request-executor";

export class DesignSystemSourcesEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  create(dsId: string, payload: DTODataSourceFigmaCreatePayload | DTODataSourceStorybookCreatePayload) {
    return this.requestExecutor.json(`/design-systems/${dsId}/sources`, DTODataSourceResponse, {
      method: "POST",
      body: payload,
    });
  }

  list(dsId: string) {
    return this.requestExecutor.json(`/design-systems/${dsId}/sources`, DTODataSourcesListResponse);
  }

  get(dsId: string, sourceId: string) {
    return this.requestExecutor.json(`/design-systems/${dsId}/sources/${sourceId}`, DTODataSourceResponse);
  }

  delete(dsId: string, sourceId: string) {
    return this.requestExecutor.json(`/design-systems/${dsId}/sources/${sourceId}`, z.any(), { method: "DELETE" });
  }

  updateFigmaSource(dsId: string, sourceId: string, payload: DTOFigmaSourceUpdatePayload) {
    return this.requestExecutor.json(`/design-systems/${dsId}/sources/${sourceId}`, DTODataSourceResponse, {
      method: "PUT",
      body: payload,
    });
  }

  updateStorybookSource(dsId: string, sourceId: string, payload: DTOStorybookSourceUpdatePayload) {
    return this.requestExecutor.json(`/design-systems/${dsId}/sources/${sourceId}`, DTODataSourceResponse, {
      method: "PUT",
      body: payload,
    });
  }

  figmaImport(dsId: string, payload: DTODataSourceFigmaImportPayload) {
    return this.requestExecutor.json(`/design-systems/${dsId}/versions/head/cloud-import`, DTOImportJobResponse, {
      method: "POST",
      body: payload,
    });
  }

  storybookImport(dsId: string, payload: DTOStorybookImportPayload) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/versions/head/storybook-import`,
      DTODataSourcesStorybookResponse,
      {
        method: "POST",
        body: payload,
      }
    );
  }

  updateStorybookImport(dsId: string, versionId: string, payload: DTOStorybookImportPayload) {
    return this.requestExecutor.json(
      `/design-systems/${dsId}/versions/${versionId}/storybook-import`,
      DTODataSourcesStorybookResponse,
      {
        method: "POST",
        body: payload,
      }
    );
  }
}
